"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroMobile() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="hero" ref={ref} className="relative w-full !bg-[hsl(218,52%,52%)] ![padding:40px_16px_60px_16px] !h-[630px] md:![padding:64px_24px_96px_24px] md:hidden">
      <div className="container mx-auto max-w-7xl">
        <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-12 items-center ![margin:70px_0px_10px_0px]">
          
          {}
          <div className="order-1 md:order-2 flex flex-col transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] opacity-100 translate-y-0">
            <h1 className="font-display font-bold text-foreground leading-tight !text-2xl md:!text-4xl ![margin:-10px_0px_0px_0px]">Welcome to New Mavericks</h1>
          </div>

          {}
          <div className={`w-full order-2 md:order-1 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          animationDelay: "100ms"
        }}>
            <div className="relative w-full aspect-video rounded-lg overflow-hidden shadow-medium !mt-0">
              <iframe src="https://www.youtube.com/embed/stsrAzqmBI4" title="New Mavericks CEO & Executive Client Testimonials" className="absolute inset-0 w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          </div>

          {}
          <div className="order-3 md:order-2 flex flex-col gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] opacity-100 translate-y-0">
            <p className="text-white leading-relaxed !text-base md:!text-xl ![margin:10px_0px_0px_0px]">Discover how top Founders &amp; CEOs have evolved their leadership consciousness to nail clutch decisions under pressure creating &amp; protecting billions in value. <br /><br />Hear directly from them about the profound impact this has had on their business and personal lives.</p>
          </div>
        </div>
      </div>
    </section>;
}